import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  styled,
  TextField,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import BadgeStepper from 'components/BadgeStepper';

const PaperStyled = styled(Paper)`
  width: 100%;
  padding: 24px;
`;

const ContainerStyle = styled(Container)`
  display: fixed;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const TncStyle = styled(Typography)(() => ({
  fontWeight: 600,
  backgroundColor: '#FAFAFA',
  padding: 16,
  borderRadius: 4,
  textAlign: 'left'
}));

const TermAndConditionPage = () => {
  const navigate = useNavigate();

  const handleGoToRegistration = () => {
    navigate('/registration');
  };

  const { t } = useTranslation();
  return (
    <ContainerStyle>
      <PaperStyled>
        <Stack>
          <Box>
            <Typography variant="h5">{t('step1.title')}</Typography>
          </Box>
          <Box sx={{ maxWidth: 500, my: 0.5 }}>
            <Typography style={{ whiteSpace: 'pre-line' }} variant="body3">
              {t('step1.desc')}
            </Typography>
          </Box>
          <Box sx={{ maxWidth: 350 }}>
            {/* color not work */}
            <BadgeStepper />
          </Box>
          <Box>
            <Typography variant="h5">{t('step1.t&cTitle')}</Typography>
            <Box sx={{ maxWidth: 500, my: 0.5 }}>
              <Typography style={{ whiteSpace: 'pre-line' }} variant="body3">
                {t('step1.t&cDesc')}
              </Typography>
            </Box>
          </Box>
          {/* border */}
          <Box sx={{ color: `#FAFAFA` }}>
            <PaperStyled>
              <Stack>
                <TncStyle>
                  <Typography variant="h5">{t('step1.t&cContentTitle')}</Typography>
                  <Box sx={{ maxWidth: '100%', my: 3 }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        maxHeight: 250,
                        overflow: 'auto'
                      }}
                    >
                      {t('step1.t&cContentBody')}
                    </Typography>
                  </Box>
                </TncStyle>
              </Stack>
              {/* end then will remove after refacor*/}
              <Box>
                <Typography variant="body3" color={'surface.300'}>
                  Saya,
                </Typography>
              </Box>
              {/* form name */}
              <Grid container sx={{ width: '100%', pb: 5 }}>
                <Grid xs={6} spacing={1}>
                  <Typography variant="body3">Nama Lengkap PIC Perusahaan</Typography>
                </Grid>
                <Grid xs={6} spacing={1}>
                  <Typography variant="body3">Email PIC Perusahaan</Typography>
                </Grid>
                <Grid xs={6} spacing={1}>
                  <FormControl sx={{ width: '100%', paddingRight: 5 }}>
                    <TextField sx={{ py: 1 }} variant="outlined" size="small" placeholder="Name" />
                  </FormControl>
                </Grid>
                <Grid xs={6} spacing={1}>
                  <FormControl sx={{ width: '100%', paddingRight: 5 }}>
                    <TextField sx={{ py: 1 }} variant="outlined" size="small" placeholder="Name" />
                  </FormControl>
                </Grid>
              </Grid>
              <Box>
                <Typography variant="body3">Dengan ini menyatakan,</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Bahwa saya adalah pejabat yang berwenang sesuai Anggaran Dasar Perusahaan terkini atau
              pegawai yang diberikan surat kuasa oleh pejabat berwenang pada perusahaan."
                  />
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Bahwa saya telah membaca, mengerti dan memahami sepenuhnya
              informasi produk yang akan dibuka dan setuju serta bersedia tunduk pada
              syarat dan ketentuan pembukaan rekening Giro BSS"
                  />
                </FormGroup>
              </Box>
            </PaperStyled>
          </Box>
          <Box sx={{ maxWidth: 500, py: 7 }}>
            <Button sx={{ border: 1, px: 10, mx: 1 }}> Kembali </Button>
            <Button variant="contained" sx={{ px: 10, mx: 1 }} onClick={handleGoToRegistration}>
              Lanjut
            </Button>
          </Box>
        </Stack>
      </PaperStyled>
    </ContainerStyle>
  );
};

export default TermAndConditionPage;
